import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Card,
  CardContent,
  CardMedia,
  Button,
  Box,
  ToggleButtonGroup,
  ToggleButton,
  TextField,
} from "@mui/material";
import HeaderBar from "../components/HeaderBar";
import FixedBottomNavigation from "../components/FixedBottomNavigation";

const Festival = () => {
  const [festivals, setFestivals] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [region, setRegion] = useState("전체");
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    fetch("/data/festivals.json")
      .then((response) => response.json())
      .then((data) => {
        const mapped = data.records.map((item, index) => ({
          id: index,
          name: item["축제명"],
          startDate: item["축제시작일자"],
          endDate: item["축제종료일자"],
          date: `${item["축제시작일자"]} ~ ${item["축제종료일자"]}`,
          location: item["소재지도로명주소"] || item["개최장소"] || "미확인",
          description: item["축제내용"] || "설명 없음",
          link: item["홈페이지주소"] || "#",
          image: `https://source.unsplash.com/featured/400x200?festival,${index}`,
        }));

        // ✅ 최신순 정렬 (축제 시작일 기준 내림차순)
        const sorted = mapped.sort((a, b) => {
          const dateA = new Date(a.startDate);
          const dateB = new Date(b.startDate);
          return dateB - dateA; // 최신 → 오래된 순
        });

        setFestivals(sorted);
        setFiltered(sorted);
      })
      .catch((error) => console.error("Error loading festival data:", error));
  }, []);

  useEffect(() => {
    let filteredData = festivals;

    if (region !== "전체") {
      filteredData = filteredData.filter((f) =>
        f.location.includes(region)
      );
    }

    if (searchTerm.trim() !== "") {
      filteredData = filteredData.filter((f) =>
        f.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    setFiltered(filteredData);
  }, [region, searchTerm, festivals]);

  const handleRegionChange = (event, newRegion) => {
    if (newRegion !== null) {
      setRegion(newRegion);
    }
  };

  return (
    <Container sx={{ pb:0, pt:0, pl:0, pr:0}}>
      <HeaderBar title="국내 축제 정보" showBack />
      <Box sx={{pl:2,pr:2}}>
        {/* 🔍 검색 + 지역 필터 */}
        <Box sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 2 }}>
          <TextField
            label="축제 검색"
            variant="outlined"
            size="small"
            fullWidth
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <ToggleButtonGroup
            value={region}
            exclusive
            onChange={handleRegionChange}
            color="primary"
            fullWidth
          >
            <ToggleButton value="전체">전체</ToggleButton>
            <ToggleButton value="서울">서울</ToggleButton>
            <ToggleButton value="부산">부산</ToggleButton>
            <ToggleButton value="창원시">진해</ToggleButton>
          </ToggleButtonGroup>
        </Box>

        {/* 📋 축제 리스트 */}
        <Box sx={{ mt: 3 }}>
          {filtered.length === 0 ? (
            <Typography sx={{ mt: 3 }}>검색 결과가 없습니다.</Typography>
          ) : (
            filtered.map((festival) => (
              <Card key={festival.id} sx={{ mb: 3, borderRadius: 2 }}>
                <CardMedia
                  height="200"
                  alt={festival.name}
                />
                <CardContent>
                  <Typography variant="h6">{festival.name}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    📅 {festival.date} | 📍 {festival.location}
                  </Typography>
                  <Typography variant="body2" sx={{ mt: 1 }}>
                    {festival.description}
                  </Typography>
                  {festival.link !== "#" && (
                    <Button
                      size="small"
                      href={festival.link}
                      target="_blank"
                      rel="noopener"
                      sx={{ mt: 1 }}
                    >
                      홈페이지
                    </Button>
                  )}
                </CardContent>
              </Card>
            ))
          )}
        </Box>
      </Box>
      <FixedBottomNavigation />
    </Container>
  );
};

export default Festival;
